import React from 'react';

import { useDispatch } from 'react-redux';
import { setCurrentMLInputSelectedQuestionId } from 'reducers/reviewFormSlice';

import { isMobileView } from 'constants/isMobileView';
import { sendClickedOnHelpMeWriteEvent } from 'constants/mixpanelHelper';

import MavenButton from 'uiToolkitV1/MavenButton/MavenButton';
import { Tooltip } from 'uiToolkitV1/Tooltip';

const TextGenerationComp = ({ isDisabled = true, questionId, providerType }) => {
  const dispatch = useDispatch();

  const onClickHandler = () => {
    if (isDisabled) return;
    // this is needed just for competency questions because only it can have multiple question inside one single accordion panel

    sendClickedOnHelpMeWriteEvent({
      eventProperties: {
        source: providerType,
      },
    });
    setTimeout(() => {
      dispatch(setCurrentMLInputSelectedQuestionId(questionId));
    }, 100);
  };

  return (
    <Tooltip
      label={
        isDisabled
          ? 'To improve the quality of your review and rephrase it using Maven, please enter a minimum of 15 characters.'
          : 'Improve the quality of your review and rephrase it using Maven'
      }
      placement="bottom-end"
    >
      <MavenButton
        text="Help me write"
        isDisabled={isDisabled}
        onClick={onClickHandler}
        buttonProps={{
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.08) !important',
          height: isMobileView() ? '24px' : '40px',
          padding: isMobileView() ? '0px 8px !important' : '8px 16px 8px 24px !important',
          sx: { ':after': { fontSize: isMobileView() ? '10px !important' : '14px !important' } },
          startIconProps: {
            padding: '4px',
            opacity: '1',
            position: 'absolute',
            left: isMobileView() ? '-10px' : '-25px',
            top: '0px',
            width: isMobileView() ? '24px' : '48px',
            height: isMobileView() ? '24px' : '48px',
          },
        }}
      />
    </Tooltip>
  );
};

export default TextGenerationComp;
